import { Dialog } from "primereact/dialog";
import React from "react";
import localeText from "../../../../../../locale";
import { locale } from "../../../../../../utilities/locale/locale";
import LandingLinkHowItWorks from "../../../../../Landing/components/LandingLinkHowItWorks/LandingLinkHowItWorks";
import { plans } from "../../../../../../utilities/plans";

const referralExplanationModal = ({ isVisible, setNotVisible }) => {
  const currentButtonLink = plans[locale];

  return (
    <Dialog
      header={localeText("referralLinks")}
      visible={isVisible}
      className="w-30rem m-2"
      onHide={setNotVisible}
      draggable={false}
    >
      <p>{localeText("referralLinksExplanation")}</p>
      {currentButtonLink && <LandingLinkHowItWorks link={currentButtonLink} />}
    </Dialog>
  );
};

export default referralExplanationModal;
